import { render } from "./AccountTypeOptions.vue?vue&type=template&id=88bd4208&scoped=true&ts=true"
import script from "./AccountTypeOptions.vue?vue&type=script&lang=ts"
export * from "./AccountTypeOptions.vue?vue&type=script&lang=ts"

import "./AccountTypeOptions.vue?vue&type=style&index=0&id=88bd4208&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88bd4208"]])

export default __exports__